"use strict";
exports.__esModule = true;
var mapping = {};
mapping['exam_description'] = 'exam_description';
mapping['procedure_type'] = 'procedure_type';
mapping['reason_for_visit'] = 'reason_for_visit';
mapping['notes'] = 'body';
exports["default"] = mapping;
//# sourceMappingURL=case-evidence-mapping.js.map